import React from 'react';
import { Provider } from 'react-redux';
import { store, history } from './store';
import PublicRoutes from './router';
import { ThemeProvider } from 'styled-components';
import themes from './settings/themes';

import { CssBaseline } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from './theme';

import { themeConfig } from './settings';
import BaseAppHolder from './baseAppStyle';
import ErrorHandler from './pages/exceptions/errorHandler';


const BaseApp = () => {

	if( process.env.REACT_APP_DEPLOYMENT_ENV !== 'production' ) {
		var link = document.querySelector("link[rel~='icon']");
		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			document.head.appendChild(link);
		}
		link.href = '/favicon-dev.png';
	}else {
		var link = document.querySelector("link[rel~='icon']");
		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			document.head.appendChild(link);
		}
		link.href = '/favicon-prod.png';
	}

	return (<MuiThemeProvider theme={theme}>
	<ThemeProvider theme={themes[themeConfig.theme]}>
			<CssBaseline />
				<BaseAppHolder>
					<Provider store={store}>
						<ErrorHandler>
							<PublicRoutes history={history} />
						</ErrorHandler>
					</Provider>
				</BaseAppHolder>
	</ThemeProvider>
	</MuiThemeProvider>
)};

export default BaseApp;
